module.exports = __webpack_public_path__ + "static/media/breakerControl.42509cd2.svg";